export const formatNumberToCurrencyString = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '';
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export const parseInputToDouble = (rawInput) => {
  const digits = rawInput.replace(/\D/g, '');
  if (!digits) return 0;
  return parseFloat(digits) / 100;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/CurrencyInput/utils/currencyInputHelpers.js